import { useState } from "react";

export default function AccordionSection({
  title,
  children,
  defaultOpen = false,
  isOpen: controlledOpen,
  onToggle,
}) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);

  const isControlled = controlledOpen !== undefined;
  const isOpen       = isControlled ? controlledOpen : internalOpen;

  function handleToggle() {
    if (isControlled) onToggle?.();
    else setInternalOpen((v) => !v);
  }

  return (
    <div className="border-b border-gray-200">
      <button
        onClick={handleToggle}
        className="w-full flex items-center justify-between px-6 py-3.5 bg-gray-100 hover:bg-gray-200 transition-colors text-left"
      >
        <span className="text-sm font-medium text-gray-800 tracking-wide">
          {title}
        </span>
        <span className="text-gray-500 text-xs select-none">
          {isOpen ? "▲" : "▼"}
        </span>
      </button>
      {isOpen && <div className="bg-white">{children}</div>}
    </div>
  );
}
